import { PlusCircle } from 'lucide-react';

import { Button, ButtonProps } from '../ui/button';
import { cn } from '../ui/utils';

export function DataTableAddButton({ children, className, ...props }: ButtonProps) {
  return (
    <Button className={cn('text-xs', className)} variant="outline" {...props}>
      <PlusCircle />
      {children}
    </Button>
  );
}
